import { BookmarkFill } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';

import { Typography } from 'antd';

import BaseCard from '@/components/shared/BaseCard';
import { getCdnUrl } from '@/helpers';
import { ISavedLesson } from '@/interfaces/lesson';
import styled, { StyledProp } from '@/styled';

import MoreInfo from './MoreInfo';

interface Props extends StyledProp, ISavedLesson {}

const SavedLessonCard = ({ className, ...props }: Props) => {
  const { id, title, new_image, image, course_image, course_hash } = props;

  const navigate = useNavigate();

  return (
    <div className={className}>
      <BaseCard
        image={{
          src: getCdnUrl(new_image, image, course_image),
          alt: title,
          aspect: '16:9',
          onClick: () => navigate(`/curso/${course_hash}/aula/${id}`)
        }}
        extraContent={
          <div className='saved-lesson-card-mark'>
            <BookmarkFill size={32} />
          </div>
        }
        internalSpace={16}
        id={`saved-lesson-card-${id}`}
      >
        <div className='saved-lesson-card-title'>
          <Typography.Text ellipsis>{title}</Typography.Text>
        </div>
      </BaseCard>

      <MoreInfo lesson={props} className='moreInfo' />
    </div>
  );
};

export default styled(SavedLessonCard)`
  .base-card {
    border: 1px solid transparent;
    border-bottom: 0;
    border-top-right-radius: ${({ theme }) => theme.borderRadius}px;
    border-top-left-radius: ${({ theme }) => theme.borderRadius}px;
    transition: border-color 300ms;

    .saved-lesson-card-title {
      span.ant-typography {
        color: ${({ theme }) => theme.colorTextBase};
        font-size: ${({ theme }) => theme.space.pxToRem(16)};
      }
    }
  }

  .saved-lesson-card-mark {
    position: absolute;
    top: -8px;
    left: 12px;
    z-index: 2;
    color: ${({ theme }) => theme.colorIcon};

    svg {
      filter: drop-shadow(0px 1px 9px rgb(0 0 0 / 0.4));
    }
  }

  &:hover {
    .base-card {
      border-color: ${({ theme }) => theme.colorPrimary};
    }

    .moreInfo {
      opacity: 1;
      pointer-events: all;
      border-color: ${({ theme }) => theme.colorPrimary};
    }
  }
`;
